import { render, staticRenderFns } from "./RegistrationPayment.vue?vue&type=template&id=4d54ac6f&scoped=true"
import script from "./RegistrationPayment.vue?vue&type=script&lang=js"
export * from "./RegistrationPayment.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPayment.vue?vue&type=style&index=0&id=4d54ac6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54ac6f",
  null
  
)

export default component.exports